import { render, staticRenderFns } from "./CaseItem.vue?vue&type=template&id=a29d3934&scoped=true&"
import script from "./CaseItem.vue?vue&type=script&lang=js&"
export * from "./CaseItem.vue?vue&type=script&lang=js&"
import style0 from "./CaseItem.vue?vue&type=style&index=0&id=a29d3934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29d3934",
  null
  
)

export default component.exports